export default {
	name: 'DeviceLimitExceeded',
	created() {},
	data() {
		return {
			maxDevices: this.$store.state.devices.max
		};
	},
	methods: {}
};



// WEBPACK FOOTER //
// ./app/components/device-limit-exceeded/script.js